/* eslint-disable import/prefer-default-export */
/**
 * The "Show me how" demo: one video covering clip, zoom and the wow-moment buttons.
 *
 * TODO(design): swap for the final produced asset when it lands.
 */
export const VIDEO_DEMO_SRC = 'https://zoolife.tv/assets/guidedTour/habitat-onboarding.mp4';
